import { useState } from 'react';
import { type Option, PlayersStatisticsFilters, TabType, TournamentsStatisticsFilters } from './types';
import { PlayerServiceGetPlayersStatisticsResponse, TournamentGetTournamentsStatisticsResponse } from '@/api';

export const useStatistics = () => {
    const [playersStatistics, setPlayersStatistics] = useState<PlayerServiceGetPlayersStatisticsResponse>();
    const [tournamentsStatistics, setTournamentsStatistics] = useState<TournamentGetTournamentsStatisticsResponse>();
    const [playersLocations, setPlayersLocations] = useState<Option[]>();
    const [tournamentsLocations, setTournamentsLocations] = useState<Option[]>();

    const [playersFilters, setPlayersFilters] = useState<PlayersStatisticsFilters>({
        query: {
            minRating: -1000,
            maxRating: 3000,
        },
    });
    const [tournamentsFilters, setTournamentsFilters] = useState<TournamentsStatisticsFilters>({});

    const [activeTab, setActiveTab] = useState<TabType>('players');

    const [loading, setLoading] = useState(false);

    return {
        playersStatistics,
        tournamentsStatistics,
        playersLocations,
        tournamentsLocations,
        playersFilters,
        tournamentsFilters,
        activeTab,
        loading,

        setPlayersStatistics,
        setTournamentsStatistics,
        setPlayersLocations,
        setTournamentsLocations,
        setPlayersFilters,
        setTournamentsFilters,
        setActiveTab,
        setLoading,
    };
};
